/**
 * Single source of truth for the user-facing app version.
 * Keep this in sync with the newest entry in backend/whatsnew_registry.py.
 */
export const APP_VERSION = 'v2.6.3';
